import BasicPortlet from "../components/basicPortlet.js";
import React from "react";
import { browserHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBezierCurve, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import Image from "../components/image";
import Load from '../components/loadAction';

class NoModelComponent extends React.Component {
    constructor(props) {
        super(props);
        
        this.go_to_configure_page = this.go_to_configure_page.bind(this);
        // setUpBotton this variable for the to show configure datasource if the user have no integration details
        this.state = { setUpBotton: false }
    }

    go_to_configure_page() {        
        if (this.props.selectedTab === "PIPELINE"){
        let redirectPage = "/pipeline"
        if (this.props.navigatePage !== undefined) {
            redirectPage = this.props.navigatePage
        }
        browserHistory.push(redirectPage);
        }
        else{
                let redirectPage = "/pipeline"
                if(this.props.navigatePage !== undefined){
                    redirectPage = this.props.navigatePage
                }
                browserHistory.push(redirectPage);
            }
    }

    componentDidMount() {
        if (this.props.noDataFound !== null || this.props.noDataFound === true) {
            this.setState({ setUpBotton: true })
        }
    }

    render() {
        let buttonName = "Configure Datasource";
        let noContentSubtext = "No datasource configured yet.";
        if (this.props.customButtonName !== undefined) {
            buttonName = this.props.customButtonName;
        }

        if (this.props.noContentSubtext !== undefined) {
            noContentSubtext = this.props.noContentSubtext;
        }
        return (
            <>
                {
                    // here we will check the undefined and the setUpBotton status if it is false means we will show the 
                    // loader if it is true means we will show the configure datasource button
                    this.state.setUpBotton ?
                        <BasicPortlet
                            className="mb-0 pb-0 w-100" bodyClassName="pb-0 h-100"
                            hidePortletTitle = {true}
                            content={
                                <div className="col-md-8 offset-md-2 text-center p-5 h-100">
                                    {/* <div className="row"> */}
                                    <div className="p-5">
                                        {this.props.realtime !== true ?
                                            <i className="d-inline-block mb-3">
                                                <Image src="icon_configure" />
                                            </i>
                                            :
                                            ""
                                        }

                                        {
                                            (this.props.isInProgress !== undefined && this.props.isInProgress === true) ?
                                                <h4 className="mb-3">{this.props.message}</h4>
                                                :
                                                (this.props.realtime === true ?
                                                    <>
                                                        <div className="row">
                                                            <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                                                                <div className="placeholder-msg">
                                                                    <div className="placeholder-msg__icon">
                                                                        <Image src="icon_placeholder_pipeline_configure" />
                                                                    </div>
                                                                    <div className="placeholder-msg__text">
                                                                        <h6>{this.props.selectedTab === "DQ" ? "No Datasources" : "No Pipelines"}</h6>
                                                                        <p>{this.props.selectedTab === "DQ" ? "Please Configure datasource." : "Please Configure pipeline."}</p>
                                                                    </div>
                                                                    <div className="placeholder-msg__action">
                                                                        <button onClick={this.go_to_configure_page} className="btn btn-outline btn-grey btn-circle"><i><FontAwesomeIcon icon={faPlusCircle} /></i>{this.props.selectedTab === "DQ" ? "Configure Datasource":"Configure Pipeline"}</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <p>
                                                            {noContentSubtext}
                                                        </p>
                                                        <div className="d-flex justify-content-center">
                                                            <button type="button"
                                                                onClick={this.go_to_configure_page}
                                                                className="btn btn-primary mb-2">
                                                                <i>
                                                                    <FontAwesomeIcon icon={faBezierCurve} />
                                                                </i>  {buttonName}
                                                            </button>
                                                        </div>
                                                    </>)
                                        }
                                    </div>
                                    {/* </div> */}
                                </div>
                            }
                        />
                        :
                        (this.props.model === true ?
                            <BasicPortlet
                                className="mb-0 pb-0" bodyClassName="pb-0"
                                content={
                                    <div className="col-md-8 offset-md-2 text-center p-5">
                                        <div className="p-5">
                                            <i className="d-inline-block mb-3">
                                                <Image src="icon_configure" />
                                            </i>
                                            <p>{noContentSubtext}</p>
                                            <div className="d-flex justify-content-center">
                                                <button type="button"
                                                    onClick={this.go_to_configure_page}
                                                    className="btn btn-primary mb-2">
                                                    <i>
                                                        <FontAwesomeIcon icon={faBezierCurve} />
                                                    </i>  {buttonName}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            />
                            :
                            <Load />
                        )
                }
            </>)
    }
}


export default NoModelComponent;
